/* eslint-disable react/forbid-prop-types */
import React, { useState, useCallback, useRef, useEffect } from "react";
import { bool, func, node, object, string } from "prop-types";
import context from "./context";
import onOutsideClick from "../click-outside";

function DropDownProvider({
	settings,
	changeCurrentAction,
	initialAction,
	currentAction,
	initialState = false,
	children,
}) {
	const [isOpen, setState] = useState(initialState);
	const containerRef = useRef(null);

	const open = useCallback(() => {
		setState(true);
	}, []);
	const close = useCallback(() => {
		setState(false);
	}, []);
	const toggle = useCallback(() => {
		setState(state => !state);
	}, [isOpen]);

	useEffect(() => {
		const { current } = containerRef;
		return current != null ? onOutsideClick(current, close) : undefined;
	}, []);
	return (
		<context.Provider
			value={{
				isOpen,
				changeCurrentAction,
				initialAction,
				currentAction,
				open,
				close,
				toggle,
				settings,
				containerRef,
			}}
		>
			{children}
		</context.Provider>
	);
}

DropDownProvider.propTypes = {
	settings: object,
	initialAction: string,
	currentAction: string,
	changeCurrentAction: func,
	initialState: bool,
	children: node,
};

export const DropDownConsumer = context.Consumer;
export default DropDownProvider;
